import { DirectiveBinding, VNode } from 'vue';

export const clickOutside = () => ({
  beforeMount(el: HTMLElement, binding: DirectiveBinding, vNode: VNode) {
    // @ts-ignore
     
    el.__click_out_side_fn__ = (event: any) => {
      if (!(el === event.target || el.contains(event.target))) {
        // @ts-ignore
        binding.value(event);
        event.stopPropagation();
      }
    };
    // @ts-ignore
     
    document.body.addEventListener('click', el.__click_out_side_fn__);
  },
  unmounted(el: HTMLElement) {
    // @ts-ignore
     
    document.body.removeEventListener('click', el.__click_out_side_fn__);
  },
});
